import { StudentDashboardPage } from "./page"

export default StudentDashboardPage
